module.exports = __webpack_public_path__ + "img/who-are-we-img-5.98765be5.png";